import { Container } from 'pixi.js';
import type { SolverHistoryStep } from './types';
import { BoardModel } from '../boardMVC/models/board/BoardModel';
import { BoardView } from '../boardMVC/views/board/BoardView';
import { SolverTrayView } from './SolverTrayView';
import { createTasksViewGroup } from '../tasks/views/createTasksViewGroup';
import { BoardViewScheduler } from '../boardMVC/models/board/ViewScheduler';
import { BoardViewFactory } from '../boardMVC/views/board/BoardViewFactory';
import { TileModel } from '../boardMVC/models/board/TileModel';

export class SolverVisualisationStepView extends Container {
  private readonly viewFactory = new BoardViewFactory();

  constructor(step: SolverHistoryStep) {
    super();
    this.createStaticPreview(step);
    this.createLivePreview(step);
  }

  public animateMove(): void {}

  private createStaticPreview(step: SolverHistoryStep): void {
    const model = new BoardModel({
      state: step.boardModel,
    });

    const boardView = new BoardView(model, this.viewFactory).props({
      parent: this,
      x: 100,
      y: 200,
    });

    new SolverTrayView(this.viewFactory, step.trayModel, step.move.fromStack).props({
      parent: this,
      x: 100,
      y: 100,
    });

    boardView.highlightLayer.setXYHighlight(step.move.toStack.x, step.move.toStack.y, true, true);

    createTasksViewGroup(step.progress, { forceBasic: true, incompleteOnly: false }).container.props({
      parent: boardView,
    });
  }

  private createLivePreview(step: SolverHistoryStep): void {
    const liveScheduler = new BoardViewScheduler();
    const liveModel = new BoardModel({
      state: step.boardModel,
      scheduler: liveScheduler,
    });

    const liveView = new BoardView(liveModel, new BoardViewFactory()).props({
      parent: this,
      x: 1000,
      y: 200,
    });

    const updateModel = (): void => {
      liveModel.update(1);
    };

    liveView.pixi.ticker.add(updateModel);
    liveView.on('destroyed', () => {
      liveView.pixi.ticker.remove(updateModel);
    });

    const targetStack = liveModel.getStack(step.move.toStack.x, step.move.toStack.y);

    if (!targetStack) {
      throw new Error('Cannot find target stack');
    }

    liveView.onAnimationFinished.connect((id) => {
      liveScheduler.finish(id);
    });

    this.animateMove = (): void => {
      liveModel.makeMove(
        targetStack.id,
        step.trayModel.colors[step.move.fromStack].map((color) => new TileModel(color)),
      );
      this.animateMove = (): void => {};
    };
  }
}
